const features = [
  {
    icon: 'ri-shield-check-line',
    title: '安全免费 · 无广告干扰',
    desc: '8848影院坚持完全免费观影，无隐藏收费，无弹窗广告干扰，为你提供纯净安全的观影环境，所有片源经过严格审核。',
  },
  {
    icon: 'ri-speed-up-line',
    title: '即点即播 · 极速加载',
    desc: '采用先进的CDN加速与智能码率技术，无论你在哪个网络环境下，打开即播，告别漫长的缓冲等待，流畅观影体验。',
  },
  {
    icon: 'ri-device-line',
    title: '全端适配 · 随心切换',
    desc: '从手机到平板、从笔记本到台式机，8848影院自动适配各种屏幕尺寸。更支持一键投屏，小屏秒变大银幕。',
  },
];

export default function FeaturesSection() {
  return (
    <section id="features" className="py-16 md:py-24 bg-background-100">
      <div className="w-full max-w-[1024px] mx-auto px-4 md:px-6">
        <div className="text-center mb-12">
          <span className="inline-block px-3 py-1 text-xs font-medium text-primary-300 bg-primary-500/10 rounded-full mb-4">
            平台优势
          </span>
          <h2 className="text-2xl md:text-4xl font-bold font-heading text-foreground-50 mb-3">
            为什么选择8848
          </h2>
          <p className="text-sm md:text-base text-foreground-400 max-w-[560px] mx-auto">
            三大核心优势，重新定义你的在线观影体验
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-5 md:gap-6">
          {features.map((feat, idx) => (
            <div
              key={idx}
              className="group text-center p-6 md:p-8 rounded-xl bg-background-200/70 border border-background-300/40 transition-all duration-300 hover:border-accent-500/25"
            >
              <div className="w-14 h-14 md:w-16 md:h-16 flex items-center justify-center rounded-2xl bg-accent-500/10 mx-auto mb-5 transition-all duration-300 group-hover:bg-accent-500/20">
                <i className={`${feat.icon} text-accent-400 text-xl md:text-2xl`}></i>
              </div>
              <h3 className="text-base md:text-lg font-bold text-foreground-100 mb-3 font-heading">
                {feat.title}
              </h3>
              <p className="text-sm text-foreground-500 leading-relaxed">
                {feat.desc}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}